import { Component, Input, HostListener, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';

import { DomHandler } from 'primeng/dom';


import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';

@Component({
    selector: 'agpr-iframe-dialog',
    templateUrl: './iframe-dialog.component.html',
    styleUrls: ['./iframe-dialog.component.scss'],
    standalone: false
})
export class IframeDialogComponent extends AbstractDialogComponent {
    static readonly iFrameDialogKey = 'Iframe';

    @Input() id: string;
    @Input() set url (url: string) {
        // once you clip the video (aka when the mention is saved), the little white bar on the video preview is not set properly..
        // you can fix that by setting the PlayStart.. and when this happens, it's usually when the clip is outside where the previous start was..
        // so this checks to see if there is NOT a playStartRegex (which means it's a topic or adhoc search)..
        // NOT already a playStart && if modEditorEnable (which mean it's a saved mention)
        // we then set the PlayStart to the StartDateTime.. cause thats where the video normally defaults too when it's outside
        const tempUrl = new URL(url);
        const queryString = tempUrl.search.substring(1); // Removes the "?"
        if (queryString) {
            const decodedQuery = Buffer.from(queryString, 'base64').toString('utf-8');
            const params = new URLSearchParams(decodedQuery);

            const startDateTime = params.get('StartDateTime');
            const playStart = params.get('PlayStart');
            const playStartRegex = params.get('PlayStartRegex');
            const modEditorEnable = params.get('ModEditorEnable');

            if (startDateTime && !playStartRegex && !playStart && modEditorEnable) {
                params.set('playStart', this.addOneSecondToStringTime(startDateTime));
                const updatedQueryString = params.toString();
                // for some reason, tveyes crashes, when it's %2C instead of , (comma)
                const reEncodedData = btoa(updatedQueryString.replace(/%2C/g, ','));
                this._url = new URL(`${tempUrl.origin}${tempUrl.pathname}?${reEncodedData}`);
            } else {
                this._url = new URL(url);
            }
        }
    }
    @Input() heading: string;
    @Input() showClose: boolean = true;
    @Input() frameWidth: string;
    @Input() frameHeight: string;
    @Input() minHeight: string;
    @Input() minWidth: string;
    @Input() maxWidth: string;
    @Input() showOverlay: boolean = true;
    @Input() allowAutoplay: boolean = false;

    @Output() message: EventEmitter<any> = new EventEmitter();

    @ViewChild('iframe') iframe: ElementRef;

    public zIndex: number;
    _url: URL;

    readonly buttonTypes = ButtonTypesEnum;

    constructor(
        public coreDialogService: CoreDialogService,
    ) {
        super(coreDialogService, IframeDialogComponent.iFrameDialogKey);
        this.zIndex = ++DomHandler.zindex;
    }

    /**
     * Respond to archived clip messages from critical mention
    */
    @HostListener('window:message', ['$event.origin', '$event.data'])
    public onPostMessage(origin: string, message: any) {
        if (this._url && origin === this._url.origin) {
            this.message.emit(message);
        }
    }

    postMessageToIFrame(message: string) {
        (this.iframe.nativeElement as HTMLIFrameElement).contentWindow.postMessage(message, this._url.origin);
    }

    /**
     * Action when the user clicks the "OK" button
     */
    ok(): void {
        this.closeDialog(true);
    }

    /**
     * Action when the user clicks the "Cancel" button, or closes the dialog via the "X" in the header
     */
    cancel(): void {
        this.closeDialog(false);
    }

    addOneSecondToStringTime(dateStr: string): string {
        // 1. Parse string into a Date object
        const date = new Date(dateStr);

        // 2. Add 1 second
        date.setSeconds(date.getSeconds() + 1);

        // 3. Reformat back to "MM/DD/YYYY HH:MM:SS"
        const pad = (num: number) => num.toString().padStart(2, '0');

        const month = pad(date.getMonth() + 1); // Months are 0-indexed
        const day = pad(date.getDate());
        const year = date.getFullYear();

        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());

        return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
    }
}
